import { DialogComponent, DialogCloseEvent } from '@theme/dialog';

class SalePopup extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();

    const end = Date.parse(this.dataset.end || '');
    if (!Number.isNaN(end) && Date.now() >= end) return;

    const key = this.dataset.storageKey;
    const designMode = Boolean(window.Shopify?.designMode);

    if (key && !designMode && localStorage.getItem(key)) return;

    const delay = Number(this.dataset.delay || 800);
    this.openTimer = setTimeout(() => this.showDialog(), delay);
    this.addEventListener(DialogCloseEvent.eventName, this.rememberClose);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearTimeout(this.openTimer);
    this.removeEventListener(DialogCloseEvent.eventName, this.rememberClose);
  }

  rememberClose = () => {
    const key = this.dataset.storageKey;
    if (key && !window.Shopify?.designMode) {
      localStorage.setItem(key, '1');
    }
  };
}

if (!customElements.get('sale-popup')) {
  customElements.define('sale-popup', SalePopup);
}
